import { ITask } from "../../api/Task/TaskTypes"

export default class RiskFindingUtils {
  static getFinalTask(tasks?: ITask[]): ITask | undefined {
    if (!tasks) return undefined
    if (tasks.length === 0) return undefined
    return tasks.reduce((maxElement, currentElement) => {
      return currentElement.sequence &&
        maxElement.sequence &&
        currentElement.sequence > maxElement.sequence
        ? currentElement
        : maxElement
    })
  }
}
